/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { Box, Typography } from '@material-ui/core';
import React from 'react';
import { Error } from '../Icons/generated';
import useStyles from './ErrorCard.styles';

interface ErrorCodeMessageProps {
  code?: string;
  message?: string;
  testId: string;
}

function ErrorCodeMessage(props: ErrorCodeMessageProps) {
  const { code, message, testId } = props;
  const classes = useStyles();
  return (
    <Box
      className={classes.errorCodeMessage}
      data-cyid={`${testId}-error-card-message`}
    >
      <Box className={classes.errorCodeIcon}>
        <Error fontSize="small" />
      </Box>
      <Typography variant="body1">
        <Box className={classes.errorCodeTypo}>
          {code && <Box className={classes.errorCode}>{code}</Box>}
          {message && <Box className={classes.errorMessage}>{message}</Box>}
        </Box>
      </Typography>
    </Box>
  );
}

export default ErrorCodeMessage;
